module.exports = __webpack_public_path__ + "static/img/14000388.b1518952.png";